import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    divisionLeaderId: string;
    userIds: string[];
};

export const schemaUserResolver_AreUsersInDivision = z.boolean();

export type SchemaUserResolver_AreUsersInDivision = z.infer<typeof schemaUserResolver_AreUsersInDivision>;

export type UserResolver_AreUsersInDivision = Resolver<Arguments, SchemaUserResolver_AreUsersInDivision>;
